import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import Drawer from "react-drag-drawer";
import InputMask from "react-input-mask";
import axios from "axios";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import { default_server } from "./../../services/api";
import "./../../assets/styles/AuthMethodLogin.css";
import imgLoading from "./../../assets/images/p-loader.gif";
import { playSong } from "../../utils/song";
import songsName from "../../enums/songsName";

const AuthMethodLogin = (props) => {
  const [method, setMethod] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const screeHeight = window.screen.height;

  const buttonLabelDefault = "ENTRE";
  const [BUTTON_LABEL, setButtonLabel] = useState(buttonLabelDefault);
  const regexTel =
    /^\(\d{2}\) \d{5}-\d{4}|\((?:1[2-9]|[2-9]\d)\) [5-9]\d{3}-\d{4}$/;
  const regexCnpjCpf =
    /^([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})$/;

  useEffect(() => {
    setLoading(true);
    axios(`${default_server}/operadora/?produto=M`).then((response) => {
      setData(response.data.lista_operadoras);
      setLoading(false);
    });
  }, []);

  const getFields = (
    field,
    values,
    touched,
    errors,
    handleChange,
    handleBlur
  ) => {
    console.log(values, touched.cpfcnpj);
    if (field.name === "cpfcnpj") {
      if (field.validation !== "cpf_cnpj") {
        return (
          <div className="inputWrapper">
            <input
              className="input-cpf"
              value={values.cpfcnpj}
              name={field.name}
              key={field.name}
              placeholder={field.placeholder}
              pattern={!new RegExp(field.validation)}
              required
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {errors.cpfcnpj && touched.cpfcnpj && (
              <p className="auth_login_error">{errors.cpfcnpj}</p>
            )}
          </div>
        );
      } else {
        return (
          <div className="inputWrapper">
            <InputMask
              value={values.cpfcnpj}
              name={field.name}
              key={field.name}
              mask={
                values.cpfcnpj.length <= 14
                  ? "999.999.999-9999999"
                  : "99.999.999/9999-99"
              }
              placeholder="CPF / CNPJ"
              maskChar={null}
              onChange={handleChange}
              className="input-cpf"
              onBlur={handleBlur}
            />
            {errors.cpfcnpj && touched.cpfcnpj && (
              <p className="auth_login_error">{errors.cpfcnpj}</p>
            )}
          </div>
        );
      }
    }

    if (field.name === "msisdn") {
      return (
        <div className="inputWrapper">
          <InputMask
            type="tel"
            mask="(99) 99999-9999"
            maskChar={null}
            name={field.name}
            key={field.name}
            value={values.msisdn}
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder={field.placeholder}
            required
            onClick={() => window.scrollTo(0, screeHeight * 0.25)}
          />
          {errors.msisdn && touched.msisdn && (
            <p className="auth_login_error">{errors.msisdn}</p>
          )}
        </div>
      );
    }

    if (field.name === "username") {
      return (
        <div className="inputWrapper">
          <input
            type="text"
            name={field.name}
            placeholder={field.placeholder}
            key={field.name}
            value={values.username}
            required
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.username && touched.username && (
            <p className="auth_login_error">{errors.username}</p>
          )}
        </div>
      );
    }

    if (field.name === "password") {
      return (
        <div className="inputWrapper">
          <input
            key={field.name}
            type="password"
            name="password"
            placeholder={field.placeholder}
            required
            onBlur={handleBlur}
            pattern={field.validation}
            value={values.password}
            onChange={handleChange}
            onClick={() => window.scrollTo(0, screeHeight * 0.25)}
          />
          {errors.password && touched.password && (
            <p className="auth_login_error">{errors.password}</p>
          )}
        </div>
      );
    }
  };

  if (!method) {
    return (
      <div className="auth-method-login">
        <p className="auth_method_title">
          ESCOLHA A FORMA DE COMEÇAR A NAVEGAR
        </p>
        <div className="auth_method_list">
          {loading ? (
            <img
              src={imgLoading}
              alt={"Loading..."}
              className="auth_method_list_loading"
            />
          ) : (
            data.map((item, index) => {
              return (
                <div
                  className="auth_method_item"
                  onMouseEnter={() => playSong(songsName.TAP)}
                  onClick={() => {
                    playSong(songsName.TAP)
                    setMethod(item)
                  }}
                  key={index}
                >
                  <div className="auth_method_item_infos">
                    <img src={item.icon} alt={`item${index}`} />
                    <span>{item.operadora}</span>
                  </div>
                  <MdKeyboardArrowRight size={40} color="#000000AA" />
                </div>
              );
            })
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="auth_login_container">
      <div
        className="auth_method_item"
        onClick={() => {
          playSong(songsName.TAP)
          setMethod(!method)
        }}
      >
        <div className="auth_method_item_infos" onMouseEnter={() => playSong(songsName.TAP)}>
          <MdKeyboardArrowLeft size={40} color="#000000AA" />
          <img src={method.icon} alt={method.operadora} />
          <span>{method.operadora}</span>
        </div>
      </div>
      <Formik
        initialValues={{ msisdn: "", password: "", cpfcnpj: "", username: "" }}
        validate={(values) => {
          const errors = {};

          method.formfieldslogin.map((field) => {
            if (field.name === "username") {
              if (!new RegExp(field.validation).test(values.username)) {
                errors.username = field.validation_message;
              }

              if (values.username === "") {
                errors.username = "Campo obrigatório";
              }
            }

            if (field.name === "cpfcnpj") {
              if (field.validation === "cpf_cnpj") {
                if (values.cpfcnpj.match(regexCnpjCpf) === null) {
                  errors.cpfcnpj = field.validation_message;
                }
              } else {
                if (!new RegExp(field.validation).test(values.cpfcnpj)) {
                  errors.cpfcnpj = field.validation_message;
                }

                if (values.cpfcnpj === "") {
                  errors.cpfcnpj = "Campo obrigatório";
                }
              }
            }
            if (field.name === "password") {
              if (!new RegExp(field.validation).test(values.password)) {
                errors.password = field.validation_message;
              }

              if (values.password === "") {
                errors.password = "Campo obrigatório";
              }
            }

            if (field.name === "msisdn") {
              if (values.msisdn.match(regexTel) === null) {
                errors.msisdn = field.validation_message;
              }

              if (values.msisdn === "") {
                errors.msisdn = "Campo obrigatório";
              }
            }
          });

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          props.onSubmit();
          setButtonLabel("• • •");
          const { idp, auth } = method;
          const data = {
            idp,
            auth: auth.toString(),
            produto: "M",
            tipo: "3",
          };

          const msisdn =
            values.msisdn && "55" + values.msisdn.replace(/[^a-zA-Z0-9]/g, "");

          if (!!msisdn) {
            data.msisdn = msisdn;
          }

          const password = values.password;

          if (!!password) {
            data.password = password;
          }

          const cpfcnpj = values.cpfcnpj;
          if (!!cpfcnpj) {
            data.cpfcnpj = cpfcnpj.replace(/[^0-9]+/g, "");
          }

          const username = values.username;

          if (!!username) {
            data.username = username;
          }

          axios({
            method: "post",
            timeout: 20000,
            url: `${default_server}/getportfolio/`,
            headers: {
              "Content-Type": "application/json",
            },
            data: JSON.stringify(data),
          })
            .then((response) => {
              setTimeout(() => props.onComplete(response.data), 1000);
            })
            .catch((error) => {
              setTimeout(() => {
                playSong(songsName.SEAGULLS)
                props.onSubmitError()
              }, 1000);
            })
            .finally(() => {
              setTimeout(() => {
                try {
                  setSubmitting(false);
                } catch (error) { }
                try {
                  setButtonLabel(buttonLabelDefault);
                } catch (error) { }
              }, 1000);
            });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            {method.formfieldslogin.map((field) =>
              getFields(
                field,
                values,
                touched,
                errors,
                handleChange,
                handleBlur
              )
            )}
            <button
              type="submit"
              disabled={isSubmitting}
              onMouseEnter={() => playSong(songsName.TAP)}
              className="auth_login_button_login"
              onClick={() => {
                playSong(songsName.TAP)
              }}
            >
              {BUTTON_LABEL}
            </button>
            <button
              id="button-cpf"
              className="auth_login_button_other"
              onMouseEnter={() => playSong(songsName.TAP)}
              onClick={() => {
                playSong(songsName.TAP)
                setMethod(!method)
              }}
            >
              VOLTAR
            </button>
            <div
              className="button-help text-white"
              onClick={() => {
                playSong(songsName.TAP)
                setModalOpen(true)
              }}
            >
              <AiOutlineQuestionCircle onMouseEnter={() => playSong(songsName.TAP)} size={30} />
            </div>
          </form>
        )}
      </Formik>
      <Drawer dontApplyListeners={true} open={modalOpen} onRequestClose={() => setModalOpen(false)}>
        <div className="modal">
          <div className="modal-container">
            <p style={{ textAlign: "left" }}>{method.dicalogin}</p>
          </div>
          <div className="modal-button-container">
            <button
              onMouseEnter={() => playSong(songsName.TAP)}
              onClick={() => {
                playSong(songsName.TAP)
                setModalOpen(false)
              }}
            >
              FECHAR
            </button>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default AuthMethodLogin;
